import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUserSettings } from 'state/profile/hooks'
import styled from 'styled-components'
import { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import AlchemyModal, { ModalSizeModeEnum } from 'UIKit/AlchemyModal/Modal'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import Toggle from 'UIKit/Toggle'
import FiatSetting from 'views/Fiat/FiatSetting'

const MobileBalanceActionModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const { userSettings, updateSetting } = useUserSettings()
  const { t } = useTranslation()

  return (
    <AlchemyModal onDismiss={onDismiss} colorTheme="darkblue" sizeMode={ModalSizeModeEnum.Auto}>
      <ModalHeader hideStroke colorTheme="darkblue" useBackIcon={false} />
      <ModalBody gap="20px" overflowY="hidden">
        <Flex flexDirection="column">
          <StyledRow padding="0 8px">
            <Text fontSize="14px" fontWeight="500">
              {t('Hide zero balances')}
            </Text>

            <Toggle
              defaultColor="textDisable"
              checkedColor="textTertiary"
              value={userSettings.isHideZeroBalance}
              onValueChanged={(value) => updateSetting({ isHideZeroBalance: value })}
            />
          </StyledRow>

          <StyledFiatSetting />
        </Flex>
      </ModalBody>
    </AlchemyModal>
  )
}

const StyledRow = styled(Flex)`
  align-items: center;
  padding: 12px;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.radii.button};
  background-color: ${({ theme }) => theme.colors.card_primary};

  &:hover {
    background-color: ${({ theme }) => theme.colors.card_primary_active};
  }
`

const StyledFiatSetting = styled(FiatSetting)`
  height: max-content;
  margin: 12px 0 40px;
`

export default MobileBalanceActionModal
